module.exports = __webpack_public_path__ + "img/love.49eb8287.png";